/**
 * This directive is used on CQ pages (Desktop)
 * to load navAccount from ATG side.
 */

angular.module('lf.desktop')

.directive('navAccountInclude', function ($http, $compile) {
  return function link (scope, el, attrs) {
    $http.get('/components/navAccount.jsp')
      .success(function (data) {
        el.html(data);
        $compile(el.contents())(scope);
      })
      .error(function () {
        console.warn('[navAccountInclude] Error while loading `navAccount` include.');
      });
  }
});
